import { useState } from 'react';
import { ModalSheet } from '../SharedUI';
import { useT } from '../../lib/i18n/I18nContext';

const QUICK_REASONS = [
  'Waiting for materials',
  'Waiting for client',
  'Waiting for design',
  'Weather delay',
  'Other',
];

export default function DelayReasonModal({ task, onConfirm, onCancel }) {
  const { t } = useT();
  const [reason, setReason] = useState('');

  const handleChipClick = (text) => {
    setReason(text);
  };

  const handleSubmit = () => {
    if (reason.trim()) onConfirm(reason.trim());
  };

  return (
    <ModalSheet open={true} onClose={onCancel} title="Delay Reason">
      <div>
        {/* Task context */}
        {(task?.task_name || task?.name) && (
          <p style={{ fontSize: 13, color: 'var(--t2)', margin: '0 0 16px' }}>
            Blocking: <strong style={{ color: 'var(--t1)' }}>{task?.task_name || task?.name}</strong>
          </p>
        )}

        {/* Quick reason chips */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {QUICK_REASONS.map((label) => (
            <button
              key={label}
              onClick={() => handleChipClick(label)}
              style={{
                padding: '6px 14px',
                borderRadius: 9999,
                fontSize: 12,
                fontWeight: 500,
                background: reason === label ? 'var(--navy)' : 'var(--glass)',
                color: reason === label ? 'var(--card)' : 'var(--t2)',
                border: reason === label ? 'none' : '1px solid var(--bdr)',
                transition: 'all 150ms ease',
                whiteSpace: 'nowrap',
                minHeight: 32,
                cursor: 'pointer',
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Custom reason textarea */}
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t('forms.delayReason')}
          rows={3}
          style={{
            width: '100%',
            padding: 12,
            fontSize: 14,
            color: 'var(--t1)',
            background: 'var(--glass)',
            border: '1px solid var(--bdr)',
            borderRadius: 12,
            resize: 'vertical',
            outline: 'none',
            boxSizing: 'border-box',
            fontFamily: 'inherit',
          }}
        />

        {/* Action buttons */}
        <div style={{ display: 'flex', gap: 10, marginTop: 16, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 500,
              background: 'var(--glass)',
              color: 'var(--t2)',
              border: '1px solid var(--bdr)',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!reason.trim()}
            style={{
              padding: '10px 20px',
              borderRadius: 10,
              fontSize: 14,
              fontWeight: 600,
              background: reason.trim() ? 'var(--bad)' : 'var(--glass)',
              color: reason.trim() ? 'var(--card)' : 'var(--tm)',
              border: 'none',
              cursor: reason.trim() ? 'pointer' : 'not-allowed',
              opacity: reason.trim() ? 1 : 0.5,
              transition: 'all 150ms ease',
            }}
          >
            Confirm Block
          </button>
        </div>
      </div>
    </ModalSheet>
  );
}
